var userString = localStorage.getItem('user');
var remember = localStorage.getItem('remember');
var name = localStorage.getItem('name');

if (typeof remember == 'undefined') {
    remember = null;
}

var user = null;

if (userString != null) {
    user = JSON.parse(userString);
}


export default {
    namespaced: true,
    state: {
        user: user,
        remember: remember,
        name: name
    },
    getters: {
        user(state) {
            return state.user;
        },
        remember(state) {
            return state.remember;
        },
        name(state) {
            return state.name;
        }
    },
    mutations: {
        login(state, res) {
            state.user = res.user;
            state.remember = res.remember;
            state.name = res.name;

            var userString = JSON.stringify(res.user);

            localStorage.setItem('user', userString);
            localStorage.setItem('name', res.name);

            if(typeof res.remember != 'undefined') {
                if (res.remember) {
                    localStorage.setItem('remember', res.user.cell_no);
                } else {
                    localStorage.removeItem('remember');
                }
            }
        }
    },
    actions: {
        login(context, username, password) {

        },
        logout(state) {
            state.user = null;

            localStorage.removeItem('user');
        },
        init(state) {

        }
    }
}